import type { SVGProps } from 'react';
const SvgIconHelp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path
      fill="#1A202C"
      d="M19.5 12a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0M2.77 12a9.23 9.23 0 1 1 18.46 0 9.23 9.23 0 0 1-18.46 0m6.122-3.27a2.02 2.02 0 0 1 1.904-1.345h2.102a2.275 2.275 0 0 1 1.132 4.25l-1.165.668a.867.867 0 0 1-.865.85.863.863 0 0 1-.865-.865v-.486c0-.31.165-.595.436-.75l1.597-.916a.545.545 0 0 0-.27-1.017h-2.102a.28.28 0 0 0-.27.191l-.015.043a.865.865 0 0 1-1.63-.577l.014-.043zm1.954 6.732a1.154 1.154 0 1 1 2.308 0 1.154 1.154 0 0 1-2.308 0"
    />
  </svg>
);
export default SvgIconHelp;
